import { Box, Button, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { TrashCan } from '../../../common/svg/trashCan'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { findObjctByValueFromArrayOfObject, focusElemnt, getInt, navigation1 } from '../../../common/helper'
import { connect } from 'react-redux'
import { useTheme } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import LastPageIcon from '@mui/icons-material/LastPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import TablePagination from '@mui/material/TablePagination'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { crossingCityBranchMatrix } from '../../../../store/common/common_action'
import { GetCitiesWithCrossingBranch, saveCrossingChanges } from '../../../../store/generalSetting/GSAction'
import { GetDestCitiesWithCrossingBranch } from '../../../../store/generalSetting/GSAction'
import { DaysInput } from '../../../common/DaysInput'
import { useTranslation } from '../../../../i18n/I18nProvider'
const CrossingMasterTable = (props) => {
  const { GetCitiesWithCrossingBranch, data, GetDestCitiesWithCrossingBranch, crossingCityBranchMatrix, saveCrossingChanges } = props
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const { common, generalSettingReducer } = data
  const { cityList, loginData, cityBranchMatrix: cityBranchMatrixList } = { ...common }
  const { destCityWithCrossingBranchTableData, crossingCities } = generalSettingReducer
  const [tableData, setTableData] = useState([])
  const [filteredTableData, setFilteredTableData] = useState([])
  const [selectCity, setSelectCity] = useState([])
  const [sourceCityList, setSourceCityList] = useState([])
  const [destCityList, setDestCityList] = useState()
  const [max, setMax] = useState(6)
  const [timeoutId, setTimeoutId] = useState(null)

  const [saveData, setSaveData] = useState({
    CompanyID: '',
    FromCityID: '',
    UserID: '',
    ToCityIDs: '',
    CrossingBranchIDs: '0',
    CrossingBranchIDs1: '0',
    CrossingBranchIDs2: '0',
    CrossingBranchIDs3: '0',
    CrossingBranchIDs4: '0',
    CrossingBranchIDs5: '0',
    DaysToDeliver: '0',
  })
  const [disableSave, setDisableSave] = useState(true)
  const branchIdKeys = [
    'CrossingBranchID',
    'CrossingBranchID1',
    'CrossingBranchID2',
    'CrossingBranchID3',
    'CrossingBranchID4',
    'CrossingBranchID5',
  ]
  const [state, setState] = useState({
    // ListData:[],
    startIndex: 0,
    lastIndex: 8,
    Total: 0,
    TotalAmount: 0,
  })
  const { startIndex, lastIndex, Total, TotalAmount } = state

  const [columns, setColumns] = useState([])
  useEffect(() => {
    focusElemnt('cmSrcCity')
  }, [])

  useEffect(() => {
    const newCol = [
      {
        headerName: tr('cmDestCityTransitDays', 'Destination City\nTransit Days'),
        headerSx: { minWidth: '200px' },
        field: 'SN',
        dataType: 'number',
        showfilter: false,
        allowSorting: false,
      },
    ]
    for (let i = 0; i < 6; i++) {
      newCol[i + 1] = {
        headerName: tr('cmCrossingCityBranch', 'Crossing City {n}\n Crossing Branch {n}').replaceAll('{n}', String(i + 1)),
        headerSx: { minWidth: '200px' },
        field: `cross${i + 1}`,
        dataType: 'string',
        showfilter: true,
        allowSorting: false,
      }
    }
    setColumns(newCol)
  }, [translations])
  useEffect(() => {
    if (typeof loginData === 'object' && Object.keys(loginData).length !== 0) {
      const data = { CompanyID: loginData.intCompanyID }
      GetCitiesWithCrossingBranch(data)
      setSaveData({
        ...saveData,
        CompanyID: loginData.intCompanyID,
        UserID: loginData.intUserID,
      })
    }
  }, [loginData])

  useEffect(() => {
    if (destCityWithCrossingBranchTableData?.length > 0) {
      const getDestCity = destCityWithCrossingBranchTableData.map((val) => {
        let totalCrossings = 0
        branchIdKeys.forEach((key, index) => {
          if (val[key]) totalCrossings = index + 1
        })
        return { ...val, totalCrossings }
      })
      setTableData(getDestCity)
      setFilteredTableData(JSON.parse(JSON.stringify(getDestCity)))
    }
  }, [destCityWithCrossingBranchTableData])

  useEffect(() => {
    if (crossingCities?.length) {
      // Create a new array to avoid direct mutation
      const sortedList = [...crossingCities].sort((a, b) => a.CityName.trim().localeCompare(b.CityName.trim()));
      setSourceCityList(sortedList);
      setSelectCity(sortedList[0]);
    }
  }, [crossingCities]);

  const handleDaysInput = (e, item) => {
    const tableIndex = tableData.findIndex((obj) => obj.ToCityID === item.ToCityID)
    const filterTableIndex = filteredTableData.findIndex((obj) => obj.ToCityID === item.ToCityID)
    let newData = [...tableData]
    let newItem = newData[tableIndex]
    newItem.DaysToDeliver = e.target.value
    let filterData = [...filteredTableData]
    let filterItem = filterData[filterTableIndex]
    filterItem.DaysToDeliver = e.target.value
    newData[tableIndex] = newItem
    filterData[filterTableIndex] = filterItem
    setTableData(newData)
    setFilteredTableData(filterData)
    updateSaveData(item.ToCityID, undefined, '', newItem.DaysToDeliver)
  }

  const EmptyTableRow = () => {
    return (
      <TableRow>
        <TableCell colSpan={9}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
              marginBottom: '15px',
              color: 'red',
              fontSize: '14px',
            }}
          >
            <span>{tr('noResultsSelectedFilters', 'No results found for the selected filters.')}</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }
  const addCrossing = (item) => {
    const tableIndex = tableData.findIndex((obj) => obj.ToCityID === item.ToCityID)
    const filterTableIndex = filteredTableData.findIndex((obj) => obj.ToCityID === item.ToCityID)
    let newData = [...tableData]
    let newFilteredData = [...filteredTableData]
    let newItem = newData[tableIndex]
    let newFilteredItem = newFilteredData[filterTableIndex]
    newItem.totalCrossings = newItem.totalCrossings + 1
    newFilteredItem.totalCrossings = newItem.totalCrossings
    newData[tableIndex] = newItem
    newFilteredData[filterTableIndex] = newFilteredItem
    setTableData(newData)
    setFilteredTableData(newFilteredData)
  }
  const deleteCrossing = (item, key) => {
    const tableIndex = tableData.findIndex((obj) => obj.ToCityID === item.ToCityID)
    const filterTableIndex = filteredTableData.findIndex((obj) => obj.ToCityID === item.ToCityID)
    let newData = [...tableData]
    let newFilteredData = [...filteredTableData]
    let newItem = newData[tableIndex]
    let newFilteredItem = newFilteredData[filterTableIndex]
    newItem.totalCrossings = newItem.totalCrossings - 1
    newFilteredItem.totalCrossings = newItem.totalCrossings
    newData[tableIndex] = newItem
    newFilteredData[filterTableIndex] = newFilteredItem
    setTableData(newData)
    setFilteredTableData(newFilteredData)
    updateSaveData(item.ToCityID, '0', key ? key : '', newItem.DaysToDeliver)
  }
  const handleSearch = (e) => {
    const searchQuery = e.target.value.toLowerCase()

    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    const newTimeoutId = setTimeout(() => {
      const filteredData = tableData.filter((item) => {
        return item.ToCityName.toLowerCase().includes(searchQuery)
      })
      setFilteredTableData(filteredData)
    }, 300) // 300 milliseconds delay

    setTimeoutId(newTimeoutId)
  }
  const crossingCitySelect = (city, item, i) => {
    const tableIndex = tableData.findIndex((obj) => obj.ToCityID === item.ToCityID)
    const filterTableIndex = filteredTableData.findIndex((obj) => obj.ToCityID === item.ToCityID)
    let newData = [...tableData]
    let newFilteredData = [...filteredTableData]
    let newItem = newData[tableIndex]
    let newFilteredItem = newFilteredData[filterTableIndex]
    newItem[`CrossingCityID${i ? i : ''}`] = city.CityID
    newItem[`CrossinCityName${i ? i : ''}`] = city.CityName
    newFilteredItem[`CrossingCityID${i ? i : ''}`] = city.CityID
    newFilteredItem[`CrossinCityName${i ? i : ''}`] = city.CityName
    newData[tableIndex] = newItem
    newFilteredData[filterTableIndex] = newFilteredItem
    setTableData(newData)
    setFilteredTableData(newFilteredData)
    const params = {
      CompanyID: loginData.intCompanyID,
      CityID: city.CityID,
    }
    crossingCityBranchMatrix(params)
  }
  const crossingBranchSelect = (branch, item, i) => {
    const tableIndex = tableData.findIndex((obj) => obj.ToCityID === item.ToCityID)
    const filterTableIndex = filteredTableData.findIndex((obj) => obj.ToCityID === item.ToCityID)
    let newData = [...tableData]
    let newFilteredData = [...filteredTableData]
    let newItem = newData[tableIndex]
    let newFilteredItem = newFilteredData[filterTableIndex]
    newItem[`CrossingBranchID${i ? i : ''}`] = branch.BranchID
    newItem[`CrossingBranchName${i ? i : ''}`] = branch.BranchName
    newFilteredItem[`CrossingBranchID${i ? i : ''}`] = branch.BranchID
    newFilteredItem[`CrossingBranchName${i ? i : ''}`] = branch.BranchName
    newData[tableIndex] = newItem
    newFilteredData[filterTableIndex] = newFilteredItem
    setTableData(newData)
    setFilteredTableData(newFilteredData)
    updateSaveData(item.ToCityID, branch.BranchID, i ? i : '', newItem.DaysToDeliver)
  }
  const updateSaveData = (ToCityID, CrossingBranchID, key = '', daysToDeliver) => {

    const newSaveData = { ...saveData }
    if (!newSaveData.ToCityIDs) {
      newSaveData.ToCityIDs = ToCityID + ''
    }
    const ToCityIDsArray = newSaveData.ToCityIDs.split('^')
    if (!ToCityIDsArray.includes(ToCityID + '')) {
      ToCityIDsArray.push(ToCityID + '')
    }
    // Update CrossingBranchIDsArray at the corresponding index
    const ToCityIndex = ToCityIDsArray.findIndex((id) => id === ToCityID + '')
    if (CrossingBranchID !== undefined) {
      let CrossingBranchIDsArray = newSaveData[`CrossingBranchIDs${key}`].split('^')
      if (ToCityIndex !== -1) {
        CrossingBranchIDsArray[ToCityIndex] = CrossingBranchID
      }
      
      newSaveData.ToCityIDs = ToCityIDsArray.join('^')
      let filledArray = CrossingBranchIDsArray.map(element => element ? element : "0"  );
      newSaveData[`CrossingBranchIDs${key}`] = filledArray.join('^')
    }
    // Update DaysToDeliver if provided
    if (daysToDeliver !== undefined) {
      const daysArray = newSaveData.DaysToDeliver.split('^')
      daysArray[ToCityIndex] = daysToDeliver
      newSaveData.DaysToDeliver = daysArray.join('^')
    }
    // Update state with new saveData
    setSaveData(newSaveData)
  }
  const getCityListFiltered = (item) => {
    const currentCities = [
      item.CrossingCityID,
      item.CrossingCityID1,
      item.CrossingCityID2,
      item.CrossingCityID3,
      item.CrossingCityID4,
      item.CrossingCityID5,
    ]
    let tempList = sourceCityList.filter((city) => city.CityID !== selectCity?.CityID && city.CityID !== item.ToCityID) || []
    tempList = tempList.filter((city) => currentCities.filter((id) => id === city.CityID).length < 2)
    tempList = tempList.sort((a, b) => a.CityName.trim().localeCompare(b.CityName.trim()))
    // let tempList1 = tempList.filter((val)=>val.CityID!==item.ToCityID)
    return tempList
  }
  const getCrossingBranchFilterd = (item, list) => {
    const currBranchIDs = [
      item.CrossingBranchID,
      item.CrossingBranchID1,
      item.CrossingBranchID2,
      item.CrossingBranchID3,
      item.CrossingBranchID4,
      item.CrossingBranchID5,
    ]
    if (!list) list = []
    return list.filter((branch) => !currBranchIDs.includes(branch.BranchID))
  }

  const CrossingTblRow = (props) => {
    const { item, index } = props
    return (
      <TableRow key={`foc-approval-${index}`} className="customTableRow" style={{ borderBottom: '1px solid #ddd' }}>
        <TableCell
          style={{
            '.MuiTableCellRoot': { borderBottom: 'none' },
            minWidth: '15%',
            position: 'sticky',
            left: 0,
            backgroundColor: '#F5FAFE',
            fontSize: '12px',
            maxHeight: '30px',
            color: '#444444',
            padding: '8px 8px',
          }}
        >
          {/* <Item className="input--wrapper" sx={{ ...sx.itemsx }}> */}
          <Box className='disbaled-crossing'>
            <DropDownOA
              id="revcByCity"
              width="100%"
              prevId="cmResetBtn"
              nextId="cmGoBtn"
              searchPlaceholder={tr('searchSourceCity', 'Search Source City')}
              defaultvalue={item?.ToCityName}
              portal={true}
              noCross={true}
              disabled={true}
            />
          </Box>
          <Box style={{ marginTop: '8px', zIndex: '0' }}>
            <DaysInput
              item={item}
              index={index}
              height={'28px'}
              value={item?.DaysToDeliver}
              onBlur={(e) => handleDaysInput(e, item)}
              filter={getInt}
            />
          </Box>
        </TableCell>

        {Array.from({ length: item.totalCrossings }, (_, i) => (
          <TableCell
            key={i}
            style={{
              '.MuiTableCellRoot': { borderBottom: 'none' },
              minWidth: '15%',
              fontSize: '12px',
              maxHeight: '30px',
              color: '#444444',
              padding: '8px 8px',
            }}
          >
            <Box style={{ display: 'flex', flexDirection: 'row' }}>
              <Box>
                <DropDownOA
                  data={getCityListFiltered(item)}
                  searchPlaceholder={tr('searchSourceCity', 'Search Source City')}
                  dataKey={`CityName`}
                  idKey={`CityID`}
                  value={item[`CrossinCityName${i ? i : ''}`]}
                  onSelect={(city) => crossingCitySelect(city, item, i)}
                />
              </Box>
              <span
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingLeft: '8px', cursor: 'pointer' }}
                onClick={(e) => deleteCrossing(item, i)}
              >
                <TrashCan />
              </span>
            </Box>
            <Box style={{ marginTop: '8px' }}>
              <DropDownOA
                data={getCrossingBranchFilterd(item, cityBranchMatrixList[item[`CrossingCityID${i ? i : ''}`]])}
                dataKey={`BranchName`}
                idKey={`BranchID`}
                onSelect={(branch) => {
                  crossingBranchSelect(branch, item, i)
                }}
                value={item[`CrossingBranchName${i ? i : ''}`]}
              />
            </Box>
          </TableCell>
        ))}

        {item.totalCrossings < max ? (
          <TableCell style={{ minWidth: '15%', fontSize: '12px', minHeight: '40px', color: '#444444', padding: '8px 8px' }}>
            <Box display="flex" flexDirection="column" height="100%" style={{ paddingBottom: '25px' }}>
              <Box style={{ flex: '1', display: 'flex', alignItems: 'center', boxSizing: 'border-box' }} onClick={(e) => addCrossing(item)}>
                <span style={{ color: '#0086ff', paddingRight: '5px', cursor: 'pointer' }}>
                  <AddCircleIcon />
                </span>
                <span
                  style={{
                    color: '#0086ff',
                    fontFamily: 'Roboto',
                    fontSize: '14px',
                    fontWeight: 600,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                >
                  {' '}
                  {tr('gsAdd', 'Add')}
                </span>
              </Box>
              <Box style={{ flex: '1', boxSizing: 'border-box' }}>
                <span
                  style={{
                    color: '#666',
                    verticalAlign: 'top',
                    textDecoration: 'underline',
                    fontFamily: 'Roboto',
                    fontSize: '12px',
                    fontWeight: ' 400',
                    paddingLeft: '3px',
                  }}
                >
                  {' '}
                  {tr('cmCrossingCityAndBranch', 'Crossing City and Branch {n}').replaceAll('{n}', String(item.totalCrossings))}
                </span>
              </Box>
            </Box>
          </TableCell>
        ) : (
          ''
        )}
      </TableRow>
    )
  }
  const handleGo = () => {
    setDisableSave(false)
    const obj = {
      UserID: loginData.intUserID,
      CompanyID: loginData.intCompanyID,
      BranchID: loginData.intBranchID,
      FromCityID: selectCity?.CityID,
    }
    setSaveData({
      ...saveData,
      FromCityID: selectCity?.CityID,
    })
    GetDestCitiesWithCrossingBranch(obj)
  }
  const validateSave = () => {
    return true
  }
  const handleSave = () => {
    if (validateSave()) {
      saveCrossingChanges(saveData, tr('updatedSuccessfully', 'Updated Successfully'))
    }
  }
  return (
    <Stack style={{ margin: '16px 22px', display: 'flex', flexDirection: 'column' }}>
      <Stack style={{ display: 'flex', flexDirection: 'row', gap: '15px' }}>
        <Item className="input--wrapper" sx={sx.itemsx} style={{ width: '15%' }}>
          <DropDownOA
            id="cmSrcCity"
            label={tr('selectSourceCity', 'Select Source City')}
            width="100%"
            prevId="cmResetBtn"
            nextId="cmGoBtn"
            data={sourceCityList || []}
            searchPlaceholder={tr('searchSourceCity', 'Search Source City')}
            dataKey={`CityName`}
            idKey={`CityID`}
            defaultvalue={sourceCityList?.[0]?.CityName || []}
            onSelect={(val) => setSelectCity(val)}
          />
        </Item>
        <Button
          id="cmGoBtn"
          className="btn add-btn"
          variant="contained"
          color="error"
          style={{ margin: '0', height: '40px' }}
          onKeyDown={(e) => {
            navigation1(e, 'cmResetBtn', 'cmSrcCity')
          }}
          onClick={handleGo}
        >
          {tr('goUpper', 'GO')}
        </Button>
        <Button
          id="cmResetBtn"
          style={{ margin: '0', height: '40px' }}
          className="btn cancel-btn"
          variant="outlined"
          color="error"
          disabled={disableSave}
          // onClick={() => {
          //   isEdit ? updateModal(false, mdt.UpdateAutoBrnchTransRecvModal) : updateModal(false, mdt.AutoBrnchTransRecvModal)
          // }}
          onKeyDown={(e) => {
            navigation1(e, 'cmSaveBtn', 'cmGoBtn')
          }}
        >
          {tr('cmReset', 'Reset')}
        </Button>
        <Button
          id="cmSaveBtn"
          style={{ margin: '0', height: '40px' }}
          className="btn add-btn"
          variant="contained"
          color="error"
          disabled={disableSave}
          onClick={() => handleSave()}
          onKeyDown={(e) => {
            navigation1(e, 'cmSrcCity', 'cmResetBtn')
          }}
        >
          {tr('saveTitle', 'Save')}
        </Button>
      </Stack>
      <Stack style={{ maxHeight: '70vh', marginTop: '16px', display: disableSave ? 'none' : 'block' }}>
        <TableContainer
          className="scrollBlue"
          style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px', minHeight: '500px' }}
          component={Paper}
        >
          <Table
            style={{ border: 'none', overflow: 'auto' }}
            stickyHeader
            id="focApprovalTbl"
            className="table1 table-Received "
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow key="cm-tbl-header-one" style={{ background: '#d9edff' }}>
                {columns?.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      position: index === 0 ? 'sticky' : '',
                      left: index === 0 ? '0' : '',
                      zIndex: index === 0 ? '3' : '',
                      backgroundColor: '#DAEDFE',
                      maxHeight: '40px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                      padding: '8px 8px',
                      textAlign: 'left',
                    }}
                  >
                    {col?.headerName?.split('\n').map((value, i) => (
                      <div style={{ whiteSpace: 'nowrap', maxHeight: '16px', gap: '6px' }}>{value.trim()}</div>
                    ))}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow key="cm-tbl-header-two">
                <TableCell
                  colSpan={7}
                  style={{
                    left: '0',
                    zIndex: '3',
                    position: 'sticky',
                    textAlign: 'left',
                    background: '#F5FAFE',
                    padding: '8px 8px 7px 8px',
                    color: '#444',
                    fontFamily: ' Roboto',
                    fontSize: '16px',
                    fontStyle: 'italic',
                    fontWeight: '500',
                    minHeight: '30px',
                  }}
                >
                  {tr('cmSourceCity', 'Source City:')} {selectCity?.CityName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ padding: '8px' }}>
                  <div className="filter-input" style={{ fontSize: '12px', width: '100%' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      placeholder={tr('searchDestinationCity', 'Search Destination City')}
                      onChange={handleSearch}
                      style={{ width: '100%' }}
                    />
                    <FilterAltIcon />
                  </div>
                </TableCell>
                <TableCell colSpan={6}></TableCell>
              </TableRow>
            </TableHead>
            {filteredTableData?.length > 0 ? (
              <>
                <TableBody className="filter-data-row" style={{ border: 'none' }}>
                  {filteredTableData.map((item, index) => (
                    <CrossingTblRow item={item} index={index} key={index} />
                  ))}
                </TableBody>
              </>
            ) : (
              <>
                <TableBody>
                  <EmptyTableRow />
                </TableBody>
              </>
            )}
          </Table>
        </TableContainer>
      </Stack>
    </Stack>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  GetCitiesWithCrossingBranch,
  GetDestCitiesWithCrossingBranch,
  crossingCityBranchMatrix,
  saveCrossingChanges,
}

export default connect(mapStateToProps, mapDispatchToProps)(CrossingMasterTable)